import {
  ACCOUNTKEY_CONTAINER_LIST_REQ,
  ACCOUNTKEY_CONTAINER_LIST_SUCCESS,
  ACCOUNTKEY_CONTAINER_LIST_ERROR
} from './agents.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import Container from '@/resources/models/Container'
import { OrderByEnum } from '@/constants/orderby.constants'
import { containerDetailMetaInfo } from '@/column-header/hosts/containers-meta'

const state = {
  accountKeyContainersReqStatus: '',
  accountKeyContainers: {}, // all agents container info
  accountKeyContainersSummary: {
    containerCount: 0,
    protectedCount: 0,
    unprotectedCount: 0,
    needsAttentionCount: 0,
    progressionCount: 0,
    snykVulernableCount: 0
  }
}

const getters = {
  accountKeyContainersReqStatus: state => state.accountKeyContainersReqStatus,
  accountKeyContainers: state => state.accountKeyContainers,
  accountKeyContainersSummary: state => state.accountKeyContainersSummary
}

// Best Practice - updates state
const mutations = {
  [ACCOUNTKEY_CONTAINER_LIST_REQ]: state => {
    state.accountKeyContainersReqStatus = 'loading'
  },
  [ACCOUNTKEY_CONTAINER_LIST_SUCCESS]: (state, data) => {
    state.accountKeyContainersReqStatus = 'saved'
    state.accountKeyContainers = data

    state.accountKeyContainersSummary.containerCount = data.models.length
    state.accountKeyContainersSummary.protectedCount = _.filter(data.models, { managed: true }).length
    state.accountKeyContainersSummary.unprotectedCount = _.filter(data.models, { managed: false }).length
    state.accountKeyContainersSummary.needsAttentionCount = _.filter(data.models, { needsAttention: true }).length
    state.accountKeyContainersSummary.progressionCount = _.sum(_.map(data.models, 'numProgressions'))
    state.accountKeyContainersSummary.snykVulernableCount = _.filter(data.models, container => {
      return _.indexOf(['LOW', 'MEDIUM', 'HIGH'], container.vulnerable) > -1
    }).length
  },
  [ACCOUNTKEY_CONTAINER_LIST_ERROR]: (state, errMsg) => {
    state.accountKeyContainersReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [ACCOUNTKEY_CONTAINER_LIST_REQ] (context, { type, accountKeys }) {
    return new Promise((resolve, reject) => {
      context.commit(ACCOUNTKEY_CONTAINER_LIST_REQ)
      let endpoint = `/assets/containers`
      if (type === 'CONTAINERIMAGE') {
        endpoint = `/assets/containers/image`
      }
      ApiRest()
        .post(endpoint, { type: type, keys: accountKeys, imageId: accountKeys[0] })
        .then(({ data }) => {
          let iqhubVersion = context.rootState.version.iqhubVersion
          let containers = new IQCollection(
            _.map(data, container => {
              return new Container('containerId', _.merge(container, { iqhubVersion: iqhubVersion }))
            }),
            { attributes: containerDetailMetaInfo.meta.columns },
            { defaultSort: 'numProgressions', sortOrder: OrderByEnum.DESC }
          )

          context.commit(ACCOUNTKEY_CONTAINER_LIST_SUCCESS, containers)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(ACCOUNTKEY_CONTAINER_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/agents/accountkey-containers.module.js